import { render, staticRenderFns } from "./pad-frame.vue?vue&type=template&id=6e5558aa&scoped=true"
import script from "./pad-frame.vue?vue&type=script&lang=js"
export * from "./pad-frame.vue?vue&type=script&lang=js"
import style0 from "./pad-frame.vue?vue&type=style&index=0&id=6e5558aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5558aa",
  null
  
)

export default component.exports